import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { withResourceEarlyData } from '../../utils.tsx';
import getData from './get-data/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const issueGiraNonCriticalDataResource = createResource<any>(
	withResourceEarlyData({
		type: 'ISSUE_GIRA_NON_CRITICAL_DATA',
		getKey: ({ match }) => {
			const issueKey = getIssueKey(match);
			return issueKey || '';
		},
		getData: (...args) => getData(...args),
		isBrowserOnly: true,
	}),
);
